import { Types } from '@store/types';

export const storeTotalBrandsCount = (data) => async (dispatch) => {
	dispatch({
		type: Types.STORE_CRM_BRAND_PROFILE_RELATED_INFO,
		payload: data
	});
};

export const storeProjectionChildTabName = (tabName) => async (dispatch) => {
	dispatch({
		type: Types.STORE_PROJECTION_CHILD_TAB,
		payload: tabName
	});
};

export const toggleCRMLeftSidePanel = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_CRM_LEFT_SIDE_PANEL,
		payload: data
	});
};

export const toggleCRMSalesFunnelSummary = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_CRM_SALES_FUNNEL_SUMMARY,
		payload: data
	});
};

export const toggleCRMEmptyState = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_CRM_EMPTY_STATE,
		payload: data
	});
};
export const storeCRMProducts = (data) => async (dispatch) => {
	dispatch({
		type: Types.PRODUCT_CRM_IDS_STATE,
		payload: data
	});
};
